<template>
	<!-- <el-tooltip
		effect="light"
		:content="t('aiChat.aiChatTitle')"
		:popper-class="{ showAiChat, 'ai-chat-tooltip': true }"
		placement="top"
	> -->
	<div :class="{ 'ai-chat-wrap': true }">
		<!-- 语言写死 en 会自动根据其他语言进行回答-->
		<df-messenger
			ref="dfMessenger"
			location="global"
			intent="START"
			project-id="bm-ai-424003"
			agent-id="08a15d20-1263-4bf8-858d-fccca9c87751"
			language-code="en"
			@click="dfMessengerClick"
			v-if="isClient"
		>
			<!-- <df-messenger-chat chat-title="Agent Name"></df-messenger-chat> -->
			<df-messenger-chat-bubble
				ref="dfMessengerBubble"
				:chat-title="t('aiChat.aiChatTitle')"
				:bot-actor-image="botIcon"
				:class="{ showBubble }"
				:chat-icon="botIcon"
				:placeholder-text="t('aiChat.aiChatPlaceHolder')"
				:chat-close-icon="downIcon"
				:chat-collapse-icon="closeIcon"
				:chat-title-icon="botIcon"
				:expanded="false"
				anchor
			/>
		</df-messenger>
	</div>
	<!-- </el-tooltip> -->
</template>
<script>
const botIcon = 'https://www.bitmart.com/static-file/public/icon/5fd74cab7d72f9b7988df1fc-20240704083156.png';
const closeIcon = 'https://www.bitmart.com/static-file/public/icon/4af6ad808892d0649486b268-20240704083246.png';
const downIcon = 'https://www.bitmart.com/static-file/public/icon/a782d98c2fa686e6b2539a22-20240704083406.png';

import { defineComponent, ref, computed, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';

import messages from './i18n';
const langMap = {
	en: 'en',
	'en-US': 'en',
	cn: 'zh-cn',
	cn_tw: 'zh-tw',
	'zh-CN': 'zh-cn',
	'zh-TW': 'zh-tw',
	jp: 'ja',
	'ja-JP': 'ja',
	vn: 'vi-vn',
	ru: 'ru',
	tr: 'tr',
	es: 'es',
	br: 'pt-br',
	'pt-BR': 'pt-br',
	// 'cs-CZ':
	'de-DE': 'de-de',
	'es-ES': 'es',
	'fr-FR': 'fr',
	'vi-VN': 'vi-vn',
	// 'uk-UA': ''
	'nl-NL': '',
	'tr-TR': 'tr',
	'ru-RU': 'ru',
};

export default defineComponent({
	name: 'AiChat',
	props: {
		lang: {
			type: String,
			default: 'en',
		},
	},
	setup(props, context) {
		const dfMessengerBubble = ref();
		const showBubble = ref();
		const showAiChat = ref(false);
		const clicked = ref(false);
		const messageBubbleClick = ref(false);

		const isClient = computed(() => {
			return process.client;
		});

		const { t: t } = useI18n({
			messages,
		});

		watch(
			() => showAiChat.value,
			() => {
				const initialColor = {
					'--df-messenger-chat-bubble-background': '#13c2c2',
				};
				const openColor = {
					'--df-messenger-chat-bubble-background': '#13c2c2',
				};
				if (isClient.value) {
					if (showAiChat.value) {
						Object.keys(openColor).forEach((key) => {
							document.documentElement.style.setProperty(key, openColor[key]);
						});
					} else {
						Object.keys(initialColor).forEach((key) => {
							document.documentElement.style.setProperty(key, initialColor[key]);
						});
					}
				}
			},
			{
				immediate: true,
			}
		);
		const init = () => {
			try {
				// 开启 zendesk 才会显示 ai chat 的按钮, 同时隐藏aichat对话框
				window.zE('messenger:on', 'open', () => {
					messageBubbleClick.value = true;
					dfMessengerBubble.value.closeChat();
					showBubble.value = true;
				});
				window.zE('messenger:on', 'close', () => {
					showBubble.value = false;
				});
				// ai chat 打开时候 关闭 zendesk, 同时重制 ai chat 的按钮
				window.addEventListener('df-chat-open-changed', (event) => {
					const { isOpen } = event.detail;
					if (isOpen) {
						window.zE('messenger', 'close');
					}
					if (messageBubbleClick.value) {
						showBubble.value = isOpen;
						showAiChat.value = isOpen;
					}
				});
			} catch (error) {
				console.log('insert error', error);
			}
		};
		const dfMessengerClick = async () => {
			messageBubbleClick.value = true;
			if (clicked.value) return;
			try {
				const [dfMessengerBubble, dfMessengerChat] = await waitUntilChatOpened();
				const { shadowRoot: dfMessengerChatShadowRoot } = dfMessengerChat;
				const { shadowRoot: chatShadowRoot } = dfMessengerChat;
				const { shadowRoot: dfMessengerChatInput } = chatShadowRoot.querySelector('df-messenger-user-input');
				const sendIcon = dfMessengerChatInput.querySelector('.send-icon-button-wrapper');
				const { shadowRoot: chatTitleShadowRoot } = dfMessengerChat.querySelector('df-messenger-titlebar');
				nextTick(() => {
					const closeIcon = dfMessengerChat.querySelector('.close-action');
					if (closeIcon) {
						closeIcon.style.padding = '6px 16px';
						closeIcon.style.height = '48px';
						sendIcon.style.display = 'none';
					}
					const inputStyle = createCss(`
            textarea.input-box {
              white-space: normal!important
            }
            textarea.input-box::input-placeholder{
              color:#9CB3BA;
            }
            .input-box-wrapper{
              // width: calc(100% - 16px)!important;
              outline: none !important;
            }
            .show-focus::after{
              display: none!important;
              outline: none !important;
            }
        `);
					dfMessengerChatInput.appendChild(inputStyle);
					const chatStyle = createCss(`
            .chat-wrapper{
              max-height: calc(-120px + 100vh);
              background: #fff;
            }
        `);
					dfMessengerBubble.appendChild(chatStyle);

					// const titlebarWrapper = chatTitleShadowRoot.querySelector('.titlebar-wrapper');
					// titlebarWrapper.style.margin = '-0.5px -0.5px 0 -0.5px';

					const chatWrapper = chatShadowRoot.querySelector('.chat-wrapper');
					if (chatWrapper) {
						chatWrapper.style.boxShadow = 'rgba(23, 73, 77, 0.15) 0px 20px 30px';
					}
					const { shadowRoot: chatListShadowRoot } =
						dfMessengerChatShadowRoot.querySelector('df-messenger-message-list');
					// 全局样式
					const style = createCss(`
          ::-webkit-scrollbar {
            width: 0px;
          }
          ::-webkit-scrollbar-track {
            background: transparent;
          }
        `);
					chatListShadowRoot.appendChild(style);
				});
				clicked.value = true;
			} catch (error) {
				console.log(111, error);
			}
		};
		const createCss = (content) => {
			const style = document.createElement('style');
			style.textContent = content;
			return style;
		};
		const waitUntilChatOpened = () => {
			return new Promise((resolve) => {
				const shadowRoot = dfMessengerBubble.value.shadowRoot;

				if (shadowRoot.querySelector('df-messenger-chat')) {
					return resolve([shadowRoot, shadowRoot.querySelector('df-messenger-chat')]);
				}
				const observer = new MutationObserver((mutations) => {
					if (shadowRoot.querySelector('df-messenger-chat')) {
						resolve([shadowRoot, shadowRoot.querySelector('df-messenger-chat')]);
						observer.disconnect();
					}
				});

				observer.observe(shadowRoot, {
					attributes: true,
					childList: true,
					subtree: true,
				});
			});
		};

		onMounted(() => {
			init();
		});

		return {
			dfMessengerBubble,
			showBubble,
			showAiChat,
			botIcon,
			closeIcon,
			downIcon,
			langMap,
			clicked,
			messageBubbleClick,
			dfMessengerClick,
			isClient,
			t,
		};
	},
});
</script>
<style lang="less">
.ai-chat-tooltip {
	z-index: 9999999 !important;

	&.showAiChat {
		display: none;
	}
}
.ai-chat-wrap {
	position: fixed;
	bottom: 18px;
	right: 86px;
	z-index: 99999;
	df-messenger {
		z-index: 2001;
		// position: fixed;
		height: calc(100vh - 200px);

		--df-messenger-chat-window-width: 340px;
		--df-messenger-primary-color: #13c2c2;
		--df-messenger-font-family: 'IBM Plex Sans';
		--df-messenger-font-color: #000;
		--df-messenger-font-size: 12px;
		--df-messenger-message-font-size: 14px;
		--df-messenger-default-font-size: 14px;
		--df-messenger-chat-background: #f3f6fc;
		--df-messenger-message-user-background: #d3e3fd;
		--df-messenger-message-bot-background: #fff;
		--df-messenger-chat-border: none;
		--df-messenger-internal-chat-bubble-size-offset: 70px;
		// title
		--df-messenger-titlebar-background: #13c2c2;
		--df-messenger-titlebar-font-color: #fff;
		--df-messenger-titlebar-padding: 12px;
		--df-messenger-titlebar-icon-width: 32px;
		--df-messenger-titlebar-icon-height: 28px;
		--df-messenger-titlebar-title-font-size: 20px;
		--df-messenger-titlebar-padding: 7px 14px;
		--df-messenger-titlebar-icon-font-color: #666;
		--df-messenger-chat-collapse-icon-size: 16px;
		--df-messenger-titlebar-title-font-size: 18px;
		// 输入框
		--df-messenger-input-box-padding: 12px;
		--df-messenger-input-padding: 0 16px 16px 16px;
		--df-messenger-input-box-focus-padding: 6px;
		--df-messenger-input-box-border-radius: 4px;
		--df-messenger-input-border-top: none;
		--df-messenger-input-background: #fff;
		--df-messenger-input-inner-padding: 0;
		--df-messenger-internal-input-font-size: 12px;
		--df-messenger-input-box-focus-padding: 12px;
		--df-messenger-input-box-focus-border: 1px solid #1a1b1f;
		--df-messenger-input-box-border: 1px solid transparent;
		--df-messenger-input-box-background: #eef3f5;
		--df-messenger-internal-input-font-color: #9cb3ba;
		--df-messenger-input-gutter: auto;

		// 聊天界面
		--df-messenger-chat-window-box-shadow: rgba(23, 73, 77, 0.15) 0px 20px 30px;
		--df-messenger-chat-background: #fff;
		--df-messenger-chat-border-radius: 16px;
		--df-messenger-default-chat-border-radius: 8px;
		--df-messenger-message-user-background: #ecfafa;
		--df-messenger-message-user-background-color: #ecfafa;
		--df-messenger-message-user-font-color: #1a1b1f;
		--df-messenger-default-font-color: #1a1b1f;
		--df-messenger-message-padding: 4px 8px;
		--df-messenger-titlebar-border-bottom: none;

		--df-messenger-message-actor-spacing: 4px;
		--df-messenger-card-background: #f4f6f8;
		--df-messenger-card-background-color: #f4f6f8;
		--df-messenger-message-bot-background: #f4f6f8;
		--df-messenger-chat-padding: 6px 16px;
		--df-messenger-message-actor-image-size: 20px;

		--df-messenger-message-user-actor-background: #000;
		--df-messenger-message-bot-actor-background: #000;

		--df-messenger-chat-scroll-button-background: #9cb3ba;
		--df-messenger-chat-scroll-button-font-color: #fff;
		--df-messenger-message-actor-padding: 6px;
		--df-messenger-chat-window-height: 633px;
		--df-messenger-chat-window-width: 380px;

		// bubble
		--df-messenger-chat-bubble-close-icon-transform-rotate: 0;
		--df-messenger-chat-bubble-close-icon-size: 36px;
		// 消息内部
		// --df-messenger-link-font-color:
		--df-messenger-link-border: none;
		--df-messenger-link-background: none;
	}
	df-messenger-chat-bubble {
		display: none;
		&.showBubble {
			display: unset;
		}
	}
	&.showBubble {
		df-messenger {
			--df-messenger-chat-bubble-background: #fff;
		}
	}
}
@media (max-width: 768px) {
	.ai-chat-wrap {
		display: none;
	}
}
</style>
